import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import resumeAi from "../../Assets/Projects/resumeAi.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={resumeAi}
              isBlog={false}
              title="Ai on Resume"
              description="The objective of this project is to develop an intelligent, AI-powered web platform that assists job seekers in enhancing their interview preparedness and resume quality. By leveraging Natural Language Processing (NLP), machine learning models, and real-time feedback systems, the platform aims to: "
              ghLink="https://ashwinikumar76.github.io/Resume_Analyzer-Ai/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
